import React from 'react';

const defaultValue = {
  id: null,
};

export const ArticleContext = React.createContext(defaultValue);
